import { render, staticRenderFns } from "./Box11.vue?vue&type=template&id=47862018&scoped=true&"
import script from "./Box11.vue?vue&type=script&lang=js&"
export * from "./Box11.vue?vue&type=script&lang=js&"
import style0 from "./Box11.vue?vue&type=style&index=0&id=47862018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47862018",
  null
  
)

export default component.exports